import { HTTPClient } from "../common/HTTPClient";
import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface DeliveryAttributeRequestParams {
  deliveryId: number;
  shopId: number;
  attributes: DeliveryAttribute[];
}

export interface DeliveryAttribute {
  id: number;
  key: string;
  value: string;
}

export interface DeliveryShopAttributesRequestParam {
  deliveryId: number;
  shopId: number;
}

export class ShopDeliveryClient {
  constructor(private httpClient: HTTPClient) {}

  public async getShopByDeliveryId(
    deliveryId: number,
    params: PaginationRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shop-delivery/delivery/${deliveryId}`,
      method: "GET",
      params
    });

    return data;
  }

  public async postDeliveryShopAttribute(
    params: DeliveryAttributeRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/delivery-shop-attributes",
      method: "POST",
      data: params
    });

    return data;
  }

  public async getDeliveryShopAttribute(
    params: DeliveryShopAttributesRequestParam
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/delivery-shop-attributes",
      method: "GET",
      params
    });

    return data;
  }
}
